<div class="hist-card">
    <div class="hist-pill-tabs">
        <button type="button" class="hist-pill" [class.active]="subTab === 'salarios'" (click)="setSubTab('salarios')">
            <span class="hist-pill-icon-badge"><img src="assets/img/icons/history-tab-salarios.svg" alt=""></span> Salarios
        </button>
        <button type="button" class="hist-pill" [class.active]="subTab === 'trayectoria'" (click)="setSubTab('trayectoria')">
            <span class="hist-pill-icon-badge"><img src="assets/img/icons/history-tab-trayectoria.svg" alt=""></span> Trayectoria
        </button>
        <button type="button" class="hist-pill" [class.active]="subTab === 'vacaciones'" (click)="setSubTab('vacaciones')">
            <span class="hist-pill-icon-badge"><img src="assets/img/icons/imss-tooth.svg" alt=""></span> Vacaciones y faltas
        </button>
    </div>

    <div class="hist-pill-panel">
        <ng-container *ngIf="subTab === 'salarios'">
            <app-salary-history-tab [employee]="employee" variant="compact"></app-salary-history-tab>
        </ng-container>

        <ng-container *ngIf="subTab === 'trayectoria'">
            <div class="hist-search-box">
                <img src="assets/img/icons/icon-search.svg" alt="">
                <input type="text" placeholder="Buscar..." [(ngModel)]="careerSearchTerm">
            </div>
            <div class="hist-table-wrap" *ngIf="!loadingCareer && !careerError">
                <table class="hist-table">
                    <thead>
                        <tr>
                            <th>Tipo de registro</th>
                            <th>Fecha</th>
                            <th>Estatus</th>
                            <th>Puesto</th>
                            <th class="text-end">Departamentos</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of filteredCareerRows">
                            <td>{{row.record_type}}</td>
                            <td>{{formatDate(row.date)}}</td>
                            <td>{{row.status}}</td>
                            <td>{{row.position}}</td>
                            <td class="text-end">{{row.department}}</td>
                        </tr>
                        <tr *ngIf="!filteredCareerRows.length">
                            <td colspan="5" class="text-center text-muted py-4">Sin registros de trayectoria</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="hist-empty-state" *ngIf="loadingCareer">
                <i class="ti ti-loader-2"></i>
                <p class="mb-0">Cargando trayectoria...</p>
            </div>
            <div class="hist-empty-state" *ngIf="careerError">
                <i class="ti ti-file-x"></i>
                <p class="mb-0">No se pudo cargar la trayectoria del colaborador.</p>
            </div>
        </ng-container>

        <ng-container *ngIf="subTab === 'vacaciones'">
            <div class="hist-search-box">
                <img src="assets/img/icons/icon-search.svg" alt="">
                <input type="text" placeholder="Buscar..." [(ngModel)]="leaveSearchTerm">
            </div>
            <div class="hist-table-wrap" *ngIf="!loadingLeave && !leaveError">
                <table class="hist-table">
                    <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Fecha de inicio</th>
                            <th class="text-end">Número de días</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of filteredLeaveRows">
                            <td>{{row.type}}</td>
                            <td>{{formatDate(row.start_date)}}</td>
                            <td class="text-end">{{row.days_count}}</td>
                        </tr>
                        <tr *ngIf="!filteredLeaveRows.length">
                            <td colspan="3" class="text-center text-muted py-4">Sin registros de vacaciones y faltas</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="hist-empty-state" *ngIf="loadingLeave">
                <i class="ti ti-loader-2"></i>
                <p class="mb-0">Cargando vacaciones y faltas...</p>
            </div>
            <div class="hist-empty-state" *ngIf="leaveError">
                <i class="ti ti-file-x"></i>
                <p class="mb-0">No se pudo cargar el historial de vacaciones y faltas.</p>
            </div>
        </ng-container>
    </div>
</div>
